import { Navigate, useLocation, useParams } from 'react-router-dom'
import { WORKSPACE_DEEP_LINK_PARAM, WORKSPACE_DEEP_LINK_SOURCE_PARAM, WorkspaceDeepLinkSource } from '../WorkspaceDeepLink/WorkspaceDeepLink'

import { FC } from 'react'
import { Path } from 'constants/router'

const LEGACY_SOURCE: WorkspaceDeepLinkSource = 'legacy_url'

/**
 * Forwards the legacy single-workspace page at `/workspaces-profile/:id` to the Members settings as a
 * workspace deep link: `/workspace-settings/members?workspaceId=:id&source=legacy_url`, plus the original
 * query string (UTM…). Nothing in the app links there any more, but emails sent before the backend linked
 * the settings pages still do.
 *
 * It decides nothing itself — {@link WorkspaceDeepLink} on the Members page switches the tab into the
 * workspace and sends whoever may not see its Members to profile settings. The path id always wins over a
 * stray `workspaceId` in the old query string.
 */
export const LegacyWorkspacesProfileForward: FC = () => {
  const { id = '' } = useParams<{ id: string }>()
  const { search, hash } = useLocation()

  const params = new URLSearchParams(search)
  params.set(WORKSPACE_DEEP_LINK_PARAM, id)
  params.set(WORKSPACE_DEEP_LINK_SOURCE_PARAM, LEGACY_SOURCE)

  return <Navigate replace to={{ pathname: Path.WORKSPACE_SETTINGS_MEMBERS, search: `?${params}`, hash }} />
}
